var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#997F86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2857 15.4286H13.7143C13.2596 15.4286 12.8236 15.6092 12.5021 15.9307C12.1806 16.2522 12 16.6882 12 17.1429V30.8571C12 31.3118 12.1806 31.7478 12.5021 32.0693C12.8236 32.3908 13.2596 32.5714 13.7143 32.5714H34.2857C34.7404 32.5714 35.1764 32.3908 35.4979 32.0693C35.8194 31.7478 36 31.3118 36 30.8571V17.1429C36 16.6882 35.8194 16.2522 35.4979 15.9307C35.1764 15.6092 34.7404 15.4286 34.2857 15.4286ZM32.4 17.1429L24 22.9543L15.6 17.1429H32.4ZM13.7143 30.8571V17.9229L23.5114 24.7029C23.6549 24.8024 23.8254 24.8557 24 24.8557C24.1746 24.8557 24.3451 24.8024 24.4886 24.7029L34.2857 17.9229V30.8571H13.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.7d6d66ead025912e924a62539752afb8.svg";
export { ForwardRef as ReactComponent };